<template>
  <el-carousel
    :interval="5000"
    trigger="click"
    class="banner hidden-sm-and-down"
    :height="bannerheight + 'px'"
  >
    <el-carousel-item v-for="(item, i) in carousel" :key="i" class="bananer">
      <a class="el-carousel__item" :href="item.Url" target="_blank">
        <img :src="Url + item.PictureGUID" />
      </a>
    </el-carousel-item>
    <!-- <el-carousel-item class="bananer">
        <div class="el-carousel__item">
          <img src="../assets/images/banner.jpg">
          </div>
      </el-carousel-item>
      <el-carousel-item  class="bananer">
        <div class="el-carousel__item">
          <img src="../assets/images/banner2.jpg">
          </div>
      </el-carousel-item> -->
  </el-carousel>
</template>

<script>
export default {
  name: 'CommonBanner',
  data() {
    return {
      carousel: '',
      bannerheight: '',
    }
  },
  async created() {
    let carousel = await this.$store.dispatch('_getBannerList', { ID: 1 })
    this.carousel = carousel.data.Data
  },
  mounted() {
    this.setSize()
    window.addEventListener(
      'resize',
      () => {
        this.setSize()
      },
      false
    )
  },
  methods: {
    setSize() {
      if (document.body.clientWidth / 4.12 < 388) {
        this.bannerheight = document.body.clientWidth / 4.12
      } else {
        this.bannerheight = 388
      }
    },
  },
}
</script>

<style>
.banner .el-carousel__indicators--horizontal .el-carousel__button {
  width: 10px;
  border-radius: 50%;
  height: 10px;
}
</style>
